export const TPA_COMPONENTS = {
	'wysiwyg.viewer.components.tpapps.TPASection': true,
	'wysiwyg.viewer.components.tpapps.TPAMultiSection': true,
	'wysiwyg.viewer.components.tpapps.TPAWidget': true,
	'wysiwyg.viewer.components.tpapps.TPAGluedWidget': true,
	'wysiwyg.viewer.components.tpapps.TPA3DCarousel': true,
	'wysiwyg.viewer.components.tpapps.TPA3DGallery': true,
	'tpa.viewer.components.StripSlideshow': true,
	'tpa.viewer.components.Masonry': true,
	'tpa.viewer.components.Freestyle': true,
	'tpa.viewer.components.Honeycomb': true,
	'tpa.viewer.components.Thumbnails': true,
	'tpa.viewer.components.Accordion': true,
	'tpa.viewer.components.Impress': true,
	'tpa.viewer.components.StripShowcase': true,
	'tpa.viewer.components.Collage': true,
}
